import { OrderType as ApiOrderType, OrderTypeChange } from '@/api/spec';
import { OrderType, OrderDisplayType } from '@/feature/order_entry/order_types';

/**
 * Determines the display type for an order based on its API type and prices
 */
export function getOrderDisplayType(
  apiOrderType: ApiOrderType,
  limitPrice: number | undefined,
  triggerPrice: number | undefined
): OrderDisplayType {
  if (apiOrderType === OrderTypeChange) {
    return 'change';
  }

  const isLimit = !!limitPrice;

  if (triggerPrice) {
    return isLimit ? OrderType.stopLimit : OrderType.stopMarket;
  }

  return isLimit ? OrderType.limit : OrderType.market;
}
